import React, { useEffect, useState, useMemo } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { GetState, GetCountries } from 'react-country-state-city'
import { states } from '@meprism/shared/src/utils/helpers'

interface StateInputProps {
  value: string | undefined;
  onChange: (event: any, newValue: string) => void;
  error?: boolean;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  paperSx?: any;
  inputSx?: any;
  size?: 'small' | 'medium';
  required?: boolean;
}

export const StateInput = ({
  value,
  onChange,
  error,
  helperText,
  placeholder = "State",
  disabled,
  paperSx,
  inputSx,
  size,
  required
}: StateInputProps) => {
  const [usStates, setUsStates] = useState<any[]>([])
  const statesSet = useMemo(() => new Set<string>(states), [])

  useEffect(() => {
    GetCountries().then((countries: any) => {
      const us = countries.find((c: any) => c.iso2 === 'US')
      if (!us?.id) return
      GetState(us.id).then((result: any) => {
        const filtered = result.filter((s: any) => statesSet.has(s.state_code))
        setUsStates(filtered)
      })
    })
  }, [statesSet])

  const selectedState = usStates.find((s) => s.state_code === value) || { state_code: value || '' } as any

  return (
    <Autocomplete
      fullWidth
      disableClearable
      forcePopupIcon={false}
      disabled={disabled}
      autoHighlight
      autoSelect
      slotProps={{
        paper: { sx: paperSx }
      }}
      options={usStates}
      getOptionLabel={(option) => typeof option === 'string' ? option : option.state_code}
      value={selectedState || null}
      isOptionEqualToValue={(option, val) => option.state_code === val?.state_code}
      onChange={(_e, newValue) => {
        if (newValue && typeof newValue !== 'string') {
          onChange(_e, newValue.state_code)
        } else {
          onChange(_e, '')
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          required={required}
          size={size}
          sx={inputSx}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          FormHelperTextProps={{ sx: { marginLeft: 0, marginRight: 0 } }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  )
}